import Icon from 'veui/components/Icon'

Icon.register({
  times: {
    paths: [
      {
        d: 'M23.9 21.07L42.38 2.59a2 2 0 012.83 2.82L26.73 23.9 45.2 42.38a2 2 0 01-2.83 2.83L23.9 26.73 5.4 45.2a2 2 0 01-2.82-2.83L21.07 23.9 2.59 5.4A2 2 0 115.4 2.6l18.5 18.47z'
      }
    ],
    width: '48',
    height: '48'
  }
})
